import React from "react";
import { WrappedFieldProps } from "redux-form";
import DatePicker from "@mui/lab/DatePicker";
import TextField from "@mui/material/TextField";

import { IMedAppFormField } from ".";

type DatePickerWrapperProps = WrappedFieldProps & IMedAppFormField;

const DatePickerWrapper: React.FC<DatePickerWrapperProps> = (props) => {
  const {
    placeholder,
    input,
    meta: { touched, error },
    label,
    inputExtras: others,
  } = props;
  return (
    <DatePicker
      {...input}
      label={label}
      error={!!error && touched}
      sx={{
        width: "100%",
      }}
      placeholder={placeholder}
      helperText={error}
      {...others}
      onChange={(newValue: any) => {
        try {
          if (newValue.$d) {
            input.onChange(newValue.$d);
          } else input.onChange(newValue);
        } catch (err) {
          input.onChange(newValue);
        }
      }}
      InputProps={{
        sx: {
          mr: 2,
          width: "100%",
        },
      }}
      renderInput={(params) => <TextField {...params} />}
    />
  );
};

export default DatePickerWrapper;
